export function MobileNotSupported() {
  return (
    <div id="mainContainer" className="not-supported">
      <h2>Mobile is not supported</h2>
      <h3>Please use a bigger screen</h3>
    </div>
  );
}
